import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  feedbackData: {},
  error: "",
  success: false,
  status: "",
};

const feedbackCall = createAsyncThunk("post/feedback", async ({ data }) => {
  try {
    const result = await axios.post(
      "https://apac.api.capillarytech.com/mobile/v2/api/communications/email?format=json",
      data
    );

    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(feedbackCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(feedbackCall.fulfilled, (state, action) => {
      // console.log(action.payload, "Feedback Action");
      state.loading = false;
      state.feedbackData = action?.payload?.status?.success;
      state.success = action?.payload?.status?.success;
      state.error = "";
    });
    builder.addCase(feedbackCall.rejected, (state, action) => {
      state.loading = false;
      state.feedbackData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default feedbackSlice.reducer;
export const { reset } = feedbackSlice.actions;
export { feedbackCall };
